import { useState } from 'react';
import { Workflow, MoreVertical, Trash2, Pencil, Power, PowerOff } from 'lucide-react';

export default function WorkflowCard({ workflow, onOpen, onDelete, onToggle }) {
  const [menuOpen, setMenuOpen] = useState(false);
  const isActive = workflow.active;
  const updatedAt = new Date(workflow.updatedAt || workflow.createdAt).toLocaleDateString('en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });

  return (
    <div
      className="bg-white rounded-2xl border border-gray-100 hover:border-gray-200 hover:shadow-md transition-all cursor-pointer group relative"
      onClick={() => onOpen(workflow.id)}
    >
      <div className="p-5">
        <div className="flex items-start justify-between">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 rounded-xl bg-blue-50 flex items-center justify-center">
              <Workflow className="w-5 h-5 text-[#2461DD]" />
            </div>
            <div>
              <h4 className="text-sm font-semibold text-gray-800">{workflow.name}</h4>
              {workflow.description && (
                <p className="text-xs text-gray-400 mt-0.5 line-clamp-1">{workflow.description}</p>
              )}
            </div>
          </div>
          <div className="relative">
            <button
              onClick={(e) => { e.stopPropagation(); setMenuOpen(!menuOpen); }}
              className="p-1.5 rounded-lg hover:bg-gray-100 opacity-0 group-hover:opacity-100 transition"
            >
              <MoreVertical className="w-4 h-4 text-gray-400" />
            </button>
            {menuOpen && (
              <>
                <div className="fixed inset-0 z-10" onClick={(e) => { e.stopPropagation(); setMenuOpen(false); }} />
                <div className="absolute right-0 top-8 bg-white rounded-xl shadow-lg border border-gray-100 py-1 w-44 z-20">
                  <button
                    onClick={(e) => { e.stopPropagation(); onOpen(workflow.id); setMenuOpen(false); }}
                    className="flex items-center gap-2 w-full px-3 py-2 text-sm text-gray-700 hover:bg-gray-50"
                  >
                    <Pencil className="w-3.5 h-3.5" /> Edit
                  </button>
                  <button
                    onClick={(e) => { e.stopPropagation(); onToggle(workflow.id); setMenuOpen(false); }}
                    className="flex items-center gap-2 w-full px-3 py-2 text-sm text-gray-700 hover:bg-gray-50"
                  >
                    {isActive ? <PowerOff className="w-3.5 h-3.5" /> : <Power className="w-3.5 h-3.5" />}
                    {isActive ? 'Deactivate' : 'Activate'}
                  </button>
                  <div className="h-px bg-gray-100 my-1" />
                  <button
                    onClick={(e) => { e.stopPropagation(); onDelete(workflow.id); setMenuOpen(false); }}
                    className="flex items-center gap-2 w-full px-3 py-2 text-sm text-red-500 hover:bg-red-50"
                  >
                    <Trash2 className="w-3.5 h-3.5" /> Delete
                  </button>
                </div>
              </>
            )}
          </div>
        </div>
        <div className="flex items-center gap-3 mt-4 pt-3 border-t border-gray-50">
          <span
            className={[
              'text-[10px] font-semibold px-2 py-0.5 rounded-full uppercase tracking-wide',
              isActive ? 'bg-green-100 text-green-700' : 'bg-gray-100 text-gray-500',
            ].join(' ')}
          >
            {isActive ? 'Active' : 'Draft'}
          </span>
          <span className="text-[11px] text-gray-400 ml-auto">
            Updated {updatedAt}
          </span>
        </div>
      </div>
    </div>
  );
}
